export const channelsKeys = {
	all: ['crm', 'channels'],
	types: (includeInactive = false) => ['crm', 'channels', 'types', includeInactive],
	configs: () => ['crm', 'channels', 'configs'],
};
